import appSettings from '@/app-settings.json';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'rsuite';
import { BETA_FEATURES } from '../../constants';
import * as dataSelectors from '../../data/data-selectors';
import { isBetaFeatureEnabled } from '../../data/data-selectors';
import { withNonCriticalErrorHandlingAsync } from '../../utils/errors';
import { strOracleApiSender } from '../../utils/stroracle-api-sender';

export function AdminApplyFlowButton() {
  const isFeatureFlagEnabled = useSelector(
    isBetaFeatureEnabled(BETA_FEATURES.adminApplyFlow)
  );
  const configuredAdminApplyFlows = useSelector(dataSelectors.adminApplyFlows);

  const adminApplyFlows = useMemo(() => {
    if (!configuredAdminApplyFlows)
      return [
        {
          label: 'License',
          path: 'admin-apply-str-license',
        },
      ];

    return configuredAdminApplyFlows;
  }, [configuredAdminApplyFlows]);

  const registrationPortalPlaceShortName = useSelector(
    dataSelectors.registrationPortalPlaceShortName
  );

  const launchRegistrationClientApplyFlow = useCallback(
    withNonCriticalErrorHandlingAsync(async (flowPath) => {
      const {
        data: { jwt },
      } = await strOracleApiSender.post(
        `/new-license-registration-system-tokens`
      );

      const registrationPortalBaseUrl =
        appSettings.registrationPortalUrl.replace(
          '{placeShortName}',
          registrationPortalPlaceShortName
        );
      const registrationPortalUrl = `${registrationPortalBaseUrl}/${flowPath}/?operatorLoginToken=${jwt}`;

      window.open(registrationPortalUrl);
    }),
    [registrationPortalPlaceShortName]
  );

  if (!isFeatureFlagEnabled) return null;

  return (
    <>
      {adminApplyFlows.map(({ label, path }) => (
        <Button
          key={label}
          appearance={'primary'}
          onClick={() => launchRegistrationClientApplyFlow(path)}
        >
          Create {label}
        </Button>
      ))}
    </>
  );
}
